"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutsManagement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_firebase_1 = require("react-redux-firebase");
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FilteredTable_1 = __importDefault(require("containers/TableMaker/FilteredTable"));
var filter_1 = require("utils/filter");
var tableConf_1 = __importDefault(require("./tableConf"));
var Table = (0, FilteredTable_1.default)(tableConf_1.default, [
    (0, filter_1.makeGroupDef)('Has Transfer and/or Fee Txn', function (item) { return (item.feeBankTxnAccountingId && item.transferAccountingId && 'Has Both')
        || (item.transferAccountingId && 'Has Transfer')
        || (item.feeBankTxnAccountingId && 'Has Fee Txn')
        || 'Has None'; }),
    (0, filter_1.makeGroupDef)('Company', function (item) { return item.companyName; }),
    (0, filter_1.makeGroupDef)('Date', function (item) { return (0, end2end_1.getISODate)(new Date(item.created * 1000)); }),
], [function (item) { return item.companyName; }, function (item) { return item.data.object.id; }]);
var PayoutsManagement = function () {
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return ({ collection: 'stripe_paid_payout_events', where: ['needsProcessing', '==', true] }); });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Rechargly Payouts" }), (0, jsx_runtime_1.jsx)(Table, { toolbarProps: { width: 940 } })] }));
};
exports.PayoutsManagement = PayoutsManagement;
exports.default = exports.PayoutsManagement;
